import { render, staticRenderFns } from "./OnBoardingFirstStep.vue?vue&type=template&id=0a75f39c&"
import script from "./OnBoardingFirstStep.vue?vue&type=script&lang=js&"
export * from "./OnBoardingFirstStep.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingFirstStep.vue?vue&type=style&index=0&id=0a75f39c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports